import { FlowStep, UpsertFlowStepInput } from '@varo/graphql-schema-types';
import DirectDepositBenefitsScreen from 'features/directDepositBenefits/DirectDepositBenefitsScreen/DirectDepositBenefitsScreen';
import useGetFlowStepId from 'features/onboarding/hooks/useGetFlowStepId';
import useUpsertFlowStep from 'features/onboarding/hooks/useUpsertFlowStep';
import { redirectUserToTargetRoute } from 'features/onboarding/utils/redirectUserToTargetRoute';
import React, { useCallback } from 'react';
import { AbortError } from 'shared/hooks/useCancellableMutation';

export default function Page() {
  const flowStepId = useGetFlowStepId();
  const { submitUpsertFlowStep } = useUpsertFlowStep();

  const handlePinwheelSuccess = useCallback(async () => {
    const input: UpsertFlowStepInput = {
      id: flowStepId,
      intentBasedOnboarding: {
        selection: undefined,
        didSkip: false,
      },
    };

    try {
      const result = await submitUpsertFlowStep({ input });
      if (!result.error) {
        redirectUserToTargetRoute(result.data?.upsertFlowStep as FlowStep);
      }
    } catch (error) {
      if (error instanceof AbortError) {
        return;
      }
      throw error;
    }
  }, [flowStepId, submitUpsertFlowStep]);

  return (
    <DirectDepositBenefitsScreen
      isOnboardingFlow
      flowStepId={flowStepId}
      onPinwheelSuccess={handlePinwheelSuccess}
    />
  );
}
